
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60","fill":"none","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"currentColor","stroke-miterlimit":"10","stroke-width":"2","d":"M29.82 44.09c-1.09 0-1.92-.11-2.43-.19l2.72-4.25-1.68-.67c-3.83-1.52-7.98-3.72-11.1-5.88l-1.81-1.25-.49 2.15c-.32 1.41-1.1 2.79-2.21 3.9-1.53 1.53-5.25 2.7-7.49 3.07h-.25c-.31 0-.56-.11-.78-.34-.21-.3-.31-.66-.27-1 .3-2.37 1.62-6.03 3.04-7.49.66-.58 1.24-1.02 1.83-1.37 0 0 2.15-1.4 6.77-1.4-4.62 0-6.87-1.21-6.87-1.21-.53-.26-1.14-.73-1.7-1.29-1.55-1.55-2.74-5.38-3.08-7.6-.08-.41.09-.7.25-.88l.05-.07a.94.94 0 01.74-.35c.05 0 .1 0 .15.01 2.48.31 6.18 1.65 7.61 3.09 1.18 1.18 1.96 2.54 2.2 3.83l.42 2.31 1.91-1.37c1.47-1.05 3.39-2.2 5.56-3.32l1.75-.9-4.92-5.28c1.08-.35 4.58-1.34 9-1.34 4.13 0 7.81.87 10.96 2.59l.27.15.31.03c6.58.61 12.2 3.77 14.3 8.04 0 0 1.05 2.25.68 4.79-.29 1.82-1.16 3.32-1.51 3.92l-.02.02-.07.1c-2.63 3.66-7.73 6.13-13.66 6.61l-.36.03-.31.19c-3.48 2.16-7.08 2.61-9.5 2.61l-.01.01z"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-miterlimit":"10","stroke-width":"2","d":"M24.65 21.63c3.85-1.94 10.24-4.56 15.31-3.88m-9.84 21.89c3.54 1.29 6.2 1.75 9.87 1.62"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-miterlimit":"10","stroke-width":"2","d":"M38.12 17.64c-.83 1.57-3.23 5.98-3.23 11.77 0 5.79 2.45 10.52 3.23 11.88m5.69-11.83a2.85 2.85 0 100-5.7 2.85 2.85 0 000 5.7zm-28.37-2.24c.35 1.23.35 3.43.08 4.63"}})])
          )
        }
      }
    